import { AuthenticatorSmsSetup } from "@/components/Welcome/AuthenticatorSetup/AuthenticatorSmsSetup";
import { portalRoutes } from "@/router/routes/portalRoutes.ts";

export const TwoFactorInitialSmsSetupView = () => (
  <div>
    <AuthenticatorSmsSetup
      successTarget={portalRoutes.user.security.initialSmsConfirm}
    />
  </div>
);
